<template>
    <Layout>
        <Titlebar title="Workshops" :links="links" />
        <Table :table="table" :row_action="showWorkshop" />
    </Layout>
</template>

<script>
    import { links } from '@/Mixins'
    import Table from '@/Components/Table'

    export default {
        mixins: [links],
        components: {
            Table
        },
        props: {
            table: {
                type: Object,
                default: {}
            }
        },
        methods: {
            showWorkshop(id) {
                const link = route('workshops.show', id);
                this.$inertia.visit(link);
            }
        }
    }
</script>
